import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, publishReplay, refCount, tap } from 'rxjs/operators';

import { RpcService } from '../http/rpc.service';
import { Module } from './module.model';
import { TokenService } from '../../authentication/token.service';

@Injectable()
export class ModulesService {
  public modules$: Observable<Array<Module>>;
  public moduleEnabled: Observable<boolean>;
  private _modulesSubject: BehaviorSubject<Array<Module>> = new BehaviorSubject(
    []
  );
  private _isModuleEnabledSubject: BehaviorSubject<
    boolean
  > = new BehaviorSubject(false);

  constructor(private rpc: RpcService, private tokenService: TokenService) {
    this.tokenService.tokenChanged$
      .pipe(
        tap((token: string) => {
          this.modules$ = null;
          if (!!token) {
            this.getModules(true);
          }
        })
      )
      .subscribe();

    this.moduleEnabled = this._isModuleEnabledSubject.asObservable();
    this.getModules().subscribe();
  }

  public get modulesSubject(): Observable<Array<Module>> {
    return this._modulesSubject.asObservable();
  }

  // TODO: HOS-10017 - don't use mix of Observables and BehaviourSubjects
  public getModules(forceReload: boolean = false): Observable<Array<Module>> {
    if (!this.modules$ || forceReload) {
      this.modules$ = this.rpc.makeManagerCall('getModules').pipe(
        tap((modules: any) => {
          return modules.map((module: any) => {
            return new Module(module.enabled, module.name, module.components);
          });
        }),
        tap((modules: Array<Module>) => {
          this._modulesSubject.next(modules);
        }),
        publishReplay(1),
        refCount()
      );
    }
    return this.modules$;
  }

  public getModule(moduleName: string): Observable<Module> {
    return this.getModules().pipe(
      map((modules: Array<Module>) => {
        return modules.filter((module: Module) => {
          return module.name === moduleName;
        })[0];
      })
    );
  }

  public isModuleEnabledS(moduleName: string): void {
    this.getModule(moduleName).subscribe((module: Module) => {
      this._isModuleEnabledSubject.next(module ? module.enabled : false);
    });
  }

  public isModuleEnabled(moduleName: string): Observable<boolean> {
    return this._modulesSubject.pipe(
      map((modules: Array<Module>) => {
        return modules.some((module: Module) => {
          return module.name === moduleName && module.enabled;
        });
      })
    );
  }
}
